
export function isDarkColor(hexColor) {
    const rgb = hexToRgb(hexColor)

    // fórmula de luminancia WCAG
    const luminance =
        (0.2126 * rgb.r +
            0.7152 * rgb.g +
            0.0722 * rgb.b) /
        255

    return luminance < 0.5
}

function hexToRgb(hex) {
    const cleaned = hex.replace('#', '')

    const bigint = parseInt(cleaned, 16)

    return {
        r: (bigint >> 16) & 255,
        g: (bigint >> 8) & 255,
        b: bigint & 255,
    }
}

export function unaccent(text) {
    return text.normalize("NFD").replace(/\p{Diacritic}/gu, "")
}

